module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1040.72fd947c.png";